import type { SxProps } from "@mui/material";

import {
  NudgeComponent,
  NudgeInnerContainer,
  NudgeOuterContainer,
  NudgeProps as NudgeComponentProps,
} from "./styles";

type NudgeProps = NudgeComponentProps & { containerSx?: SxProps };

const Nudge = ({ containerSx, ...props }: NudgeProps) => {
  return (
    <NudgeOuterContainer sx={containerSx}>
      <NudgeInnerContainer>
        <NudgeComponent {...props} />
      </NudgeInnerContainer>
    </NudgeOuterContainer>
  );
};

export default Nudge;
